







import CertificateGraph from "./CertificateGraph.vue";
import CertificateGraphMobile from "./mobile/certificate-graph/CertificateGraphMobile.vue";
import ResponsiveLayout from "../mixin/ResponsiveLayout.vue";

export default {
  components: {
    ResponsiveLayout,
    CertificateGraph,
    CertificateGraphMobile,
  },
  data() {
    return {
      CertificateGraphMobile,
      CertificateGraph,
    };
  },
};
